export enum EventType {
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_CART_FROM_CHAT = 'ADD_TO_CART_FROM_CHAT',
  ADD_TO_CART_FROM_UPSELL = 'ADD_TO_CART_FROM_UPSELL',
  OPEN_PRODUCT_FROM_CHAT = 'OPEN_PRODUCT_FROM_CHAT',
  VIEWED_TOOLTIP = 'VIEWED_TOOLTIP',
  CLICKED_TOOLTIP = 'CLICKED_TOOLTIP',

  // prompts
  PRODUCT_MATCH_REQUESTED = 'PRODUCT_MATCH_REQUESTED',
  INGREDIENTS_INFO_REQUESTED = 'INGREDIENTS_INFO_REQUESTED',
  USAGE_INFO_REQUESTED = 'USAGE_INFO_REQUESTED',
  BEST_SELLER_VIEW_REQUESTED = 'BEST_SELLER_VIEW_REQUESTED',
  HAIR_ROUTINE_REQUESTED = 'HAIR_ROUTINE_REQUESTED',
}
